import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useCurrentCompanyId } from "hooks/auth";
import {
  confirmVerificationWithValues,
  type ConfirmVerificationPayload,
} from "../api/insuranceVerificationApi";
import { insuranceVerificationKeys } from "../api/insuranceVerificationKeys";

interface UseConfirmVerificationOptions {
  documentId: number;
  signedParams?: { expires: string; signature: string; };
  onError?: (error: unknown) => void;
  onSuccess?: () => void;
}

export const useConfirmVerification = ({
  documentId,
  signedParams,
  onSuccess,
  onError,
}: UseConfirmVerificationOptions) => {
  const companyId = useCurrentCompanyId() as number;
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: ConfirmVerificationPayload) =>
      confirmVerificationWithValues(companyId, documentId, payload, signedParams),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.documents(companyId),
      });
      queryClient.invalidateQueries({
        queryKey: insuranceVerificationKeys.document(companyId, documentId),
      });
      onSuccess?.();
    },
    onError,
  });
};
